import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

type TQuery = {
  invoice_detail_id: number;
};

const getInvoiceDiscountingDocuments = async ({
  invoice_detail_id,
}: TQuery) => {
  const data = await getData(
    `${ajaxEndpoints.GET_INVOICE_DISCOUNT_DOCUMENTS}/${invoice_detail_id}`,
  );
  return data?.data;
};

export default function useInvoiceDiscountingDocuments({
  invoice_detail_id,
}: TQuery) {
  return useQuery(
    [{ invoice_detail_id }, "getInvoiceDiscountingDocuments"],
    getInvoiceDiscountingDocuments,
  );
}
